export default __webpack_public_path__ + "static/media/Exit.d425d78a.svg";